import React from 'react';
import { Avatar } from 'views/components/molecules/Avatar';
import styled from '@emotion/styled';
import { Color, FontSize } from 'views/constants';
import { Icon } from 'views/components/molecules/Icon';
import { Typography } from 'views/components/atoms/Typography';
import { HeaderMenu } from 'views/components/atoms/HeaderMenu';

const UserProfileWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const IconWithTextArea = styled.div`
  display: flex;
  flex-direction: column;
`;

const AvatarWrapper = styled.div`
  margin-right: 16px;
`;

const isUser = (arg: User | Email): arg is User => {
  return 'profileSrc' in arg;
};

export type User = {
  profileSrc: string;
  name: string;
  device?: string;
  reInstallProfile?: boolean;
};

export type Email = {
  email?: string;
};

interface UserProfileProps {
  info: User;
}

const UserProfile: React.FC<UserProfileProps> = ({ info }) => (
  <UserProfileWrapper>
    <AvatarWrapper>
      <Avatar src={info.profileSrc} name={info.name} />
    </AvatarWrapper>
    <IconWithTextArea>
      <Icon
        type="user"
        size="small"
        label={
          <Typography color={Color.C2} size={FontSize.S} bold>
            {info.name}
          </Typography>
        }
      />
      {info.device ? (
        <Icon
          type="device"
          size="small"
          label={
            <Typography color={Color.C2} size={FontSize.S}>
              {info.device}
            </Typography>
          }
        />
      ) : null}
    </IconWithTextArea>
  </UserProfileWrapper>
);

interface EmailProps {
  info: Email;
}

const EmailInfo: React.FC<EmailProps> = ({ info }) => {
  return info.email ? (
    <Icon
      type="user"
      size="small"
      label={
        <Typography color={Color.C2} size={FontSize.S} bold>
          {info.email}
        </Typography>
      }
      centerWithLabel
    />
  ) : null;
};

interface UserInfoProps {
  info: User | Email;
}

export const UserInfo: React.FC<UserInfoProps> = ({ info }) => {
  return !isUser(info) && !info.email ? null : (
    <HeaderMenu>
      {isUser(info) ? <UserProfile info={info} /> : <EmailInfo info={info} />}
    </HeaderMenu>
  );
};
